import { apiProxyRequest } from "Api/apiProxyRequest";

import type { ProjectAddon } from "./getProjectAddons.request";

export const updateProjectAddon = ({
  organizationId,
  projectId,
  addonId,
  data
}: {
  organizationId: string;
  projectId: string;
  addonId: string;
  data: object;
}) =>
  apiProxyRequest<ProjectAddon>(
    `/organizations/${organizationId}/projects/${projectId}/addons/${addonId}`,
    "PATCH",
    data
  );
